import Typography from '@mui/material/Typography'
import { RegularSection, SwiperV1, ColorTitle } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

interface Card {
    image?: string | Record<string, unknown>
    title?: string
    description?: string
    button?: {
        link?: string
        text?: string
    }
}

interface Content {
    title?: string
    subtitle?: string
    cards?: Card[]
}

interface S2_Hero_2Props {
    content?: Content
    blockName?:string
}

const Index = (props: S2_Hero_2Props) => {
    const { content = {} } = props
    const { title, subtitle, cards = [] } = content
    const normalizedCards = cards.map((card) => {
        const { src } = getImageData(card.image)
        return {
            ...card,
            image: src,
        }
    })
    return (
        <RegularSection aria-label='S2_Hero_2' >
            <ColorTitle title={title} colorFrom={0}/>
            <Typography
                component='h3'
                variant='subtitle1'
                sx={{ textAlign: 'center', width: { xs: '90vw', md: '40vw' } }}
            >
                {subtitle}
            </Typography>

            <SwiperV1 cards={normalizedCards}/>
        </RegularSection>
    )
}

export default Index
